(function ($) {
  $(function () {
    new WOW().init();
    $("body").prepend('<div class="left-side-color"></div>');
    $("body").append('<div class="right-side-color"></div>');
    function addedBodyColor() {
      var extraSpace = $(window).outerWidth() - 2500;
      if (extraSpace > 0) {
        var halfSpace = extraSpace / 2;
        var bodyHeight = $("body").outerHeight();
        $(".left-side-color, .right-side-color")
          .css({width: halfSpace + "px", height: bodyHeight + "px",}).toggle(true);
      } else {
        $(".left-side-color, .right-side-color").toggle(false);
      }
    }

    $(window).on("resize load", function () {
      setTimeout(addedBodyColor, 300);
    });
    addedBodyColor();
  });
})(jQuery);
// Force external links to open in new tab / window
(function($){
  $(function(){
    var siteName = window.location.host.replace('www.', '');
    $('a[href^="htt"]:not([target]):not([href*="www.' + siteName + '"]):not([href*="//' + siteName + '"]):not([class*="fancybox"])').attr('target', '_blank');
  });
})(jQuery);